<ng-container *ngIf="page && brConfig?.fundId; else previewBlock">
  <!-- start fund Overview-->
  <div class="fd-tab-sections FT-fund-overview block-border" id="overview">
    <div *ngIf="!isSegregated" class="accordion FT-customized-accordion" id="accordionExample">
      <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
          <button class="accordion-button" type="button" data-bs-toggle="collapse"
                  data-bs-target="#faq1" aria-expanded="true" aria-controls="faq1">
            {{ whatisFund }}
          </button>
        </h2>
        <div id="faq1" class="accordion-collapse collapse show" aria-labelledby="heading1">
          <div class="accordion-body">
            <div class="row col-reverse">
              <div class="col-lg-6 col-md-8 col-12" *ngIf="fundDocument?.fundkeybenefits">
                <span [innerHTML]="fundDocument?.fundtaximplication | safeHtml"></span>
              </div>
              <div class="col-lg-6 col-md-4 col-12">
                <img alt="image" class="img-fluid" [src]="bannerImage"/>
                <ng-container *ngIf="fundVideo">
                    <div class="text-center">
                      <span class="btn you-tube" data-bs-toggle="modal" data-bs-target="#fundVideoModal" style="font-size: 1rem;font-weight: 600;line-height: 20px;letter-spacing: -2%;color: #3769FF;
                                letter-spacing: 0px;padding: 6px; display: block;border: 1px solid blue;">
                      <img alt="youtube video" src="assets/images/general/YT-img.webp"/>
                      {{ "products.overview-fund-video" | translate }}
                    </span>
                    </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#faq2" aria-expanded="true" aria-controls="faq2">
            {{ whyInvestTitle }}
          </button>
        </h2>
        <div id="faq2" class="accordion-collapse collapse" aria-labelledby="heading2">
          <div class="accordion-body">
              <div *ngIf="fundDocument?.fundkeybenefits">
                <span [innerHTML]="fundDocument?.fundkeybenefits | safeHtml"></span>
              </div>
          </div>
        </div>
      </div>
      <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
          <button class="accordion-button" type="button" data-bs-toggle="collapse"
                  data-bs-target="#faq3" aria-expanded="false" aria-controls="faq3"
                  *ngIf="fundDocument?.idealinvestmenthorizon">
            {{ "products.overview-ideal-horizons" | translate }}
          </button>
        </h2>
        <div id="faq3" class="accordion-collapse collapse show" aria-labelledby="heading3">
          <!-- data-bs-parent="#accordionExample" -->
          <div class="accordion-body">
            <div class="text-meduim mb-3" *ngIf="fundDocument?.idealinvestmenthorizon">
              <span class="customP" [innerHTML]="fundDocument?.idealinvestmenthorizon"></span>
            </div>
            <div *ngIf="this.fundDocument?.fundsuitablefor?.length">
              <div class="ck-editor fund-content">
                <div class="row invest-feature ">
                  <div class="col-sm-12 col-md-3 custom-border-right text-center">
                    <h6>
                      {{ "products.overview-alternative-to" | translate }}
                    </h6>
                    <div>
                      <!-- <div class="col-xs-12"> -->
                      <img *ngIf="alternativeFor" [src]="getAlternativeToIcon(alternativeFor)"
                           width="100" height="100" alt="alternativeicon" class="imgMaxWidth"/>
                      <p>{{ alternativeFor }}</p>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-9 text-center">
                    <h6>
                      {{ "products.overview-suitable-for" | translate }}
                    </h6>
                    <div class="suitable-for-items text-center">
                      <div
                          *ngFor="let suitableFor of fundDocument.fundsuitablefor"
                          class="text-center">
                        <img [src]="getSuitableForIcon(suitableFor)" width="100" height="100" alt="icon"/>
                        <p>{{ suitableFor }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="accordion-item" *ngIf="fundDocument?.showfundsectorinformation && topTen">
        <h2 class="accordion-header" id="heading4">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#faq4" aria-expanded="false" aria-controls="faq4"
                  [innerHTML]='"products.overview-top-10" | translate'>
          </button>
        </h2>
        <div id="faq4" class="accordion-collapse collapse"
             aria-labelledby="heading4">
          <div class="accordion-body">
            <div class="mb-3">As on&nbsp;{{ topTenDate }}</div>
            <div class="row">
              <ul class="col-md-4 col-12 mb-0">
                <li class="mb-3" *ngFor="let holding of careesFirstMenu(0, 3)"
                    [innerHtml]="holding">
                </li>
              </ul>
              <ul class="col-md-4 col-12 mb-0">
                <li class="mb-3" *ngFor="let holding of careesFirstMenu(4,6)"
                    [innerHtml]="holding">
                </li>
              </ul>
              <ul class="col-md-4 col-12 mb-0">
                <li class="mb-3" *ngFor="let holding of careesFirstMenu(7,9)"
                    [innerHtml]="holding">
                </li>
              </ul>
            </div>
          </div>
          <div class="text-start d-md-block">
            <a (click)="scrollTo('portfolio')" class="login-dark2"
               style="cursor: pointer;">View all<i class="bi bi-chevron-right"></i></a>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="isSegregated">
      <div [innerHTML]="segregatedCaveats" class="ck-editor fund-content"></div>
    </ng-container>
  </div>
</ng-container>
<ng-template #previewBlock>
  <h5 *ngIf="page && page.isPreview()">Fund Content Component - Main Fund Content
  </h5>
</ng-template>

<!-- Fund Video Modal -->
<div class="modal fade" id="fundVideoModal" tabindex="-1" aria-labelledby="fundVideoModalLabel" aria-hidden="true"
     *ngIf="fundVideo" style="z-index: 1000000;top: 15%;">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="padding: 10px !important;">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body" style="padding: 5px !important;">
        <iframe width="100%" height="454" [attr.src]="fundVideo" title="Coming Soon" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen>
        </iframe>
      </div>
    </div>
  </div>
</div>
